import { useMutation } from "@tanstack/react-query";
import { updateGoogleBusinessProfileBasicInformation } from "../../api/bReviewsApi";

export const useUpdateGoogleBusinessProfileBasicInformation = () => {
  return useMutation({
    mutationFn: ({ locationId, data }) =>
      updateGoogleBusinessProfileBasicInformation(locationId, data),
  });
};
